import AsideMenuAccount from "app/pages/.shared/AsideMenu/AsideMenuAccount";

export default AsideMenuAccount;
